import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ConceptYearInterface } from '../+models';

export const CONCEPT_YEAR_SERVICE_TOKEN = new InjectionToken('ConceptYearServiceInterface');

export interface ConceptYearServiceInterface {
  getAllForUser(userId: number): Observable<ConceptYearInterface[]>;
}
